import { useMatches } from '@tanstack/react-router';

import { routesByPath } from '~/config/routes.ts';

// NOTE(OLA): Index routes have trailing "/" not reflected in type.
type Trimmed<T extends string> = T extends `${infer U}/` ? U : T;

function trimTrailingSlash<T extends string>(str: T): Trimmed<T> {
  return (str[str.length - 1] === '/' ? str.slice(0, str.length - 1) : str) as Trimmed<T>;
}

export function useMatchedRoute() {
  const _match = useMatches({ select: matches => matches.at(-1) })?.fullPath || '/';
  const match = _match !== '/' ? trimTrailingSlash(_match) : _match;

  return routesByPath[match];
}
